import { FC } from 'react';
import './WatermarkProcessing.scss';

interface Props {
  current: number;
  total: number;
}

const WatermarkProcessing: FC<Props> = ({ current, total }) => (
  <div className="watermark-processing">
    {/* Document illustration */}
    <div className="watermark-processing__doc">
      {/* Header bar with decorative dots */}
      <div className="watermark-processing__doc-header">
        <span /><span /><span />
      </div>

      {/* Text lines */}
      <div className="watermark-processing__doc-body">
        <div className="watermark-processing__doc-line" />
        <div className="watermark-processing__doc-line watermark-processing__doc-line--medium" />
        <div className="watermark-processing__doc-line watermark-processing__doc-line--short" />
        <div className="watermark-processing__doc-divider" />
        <div className="watermark-processing__doc-line" />
        <div className="watermark-processing__doc-line watermark-processing__doc-line--short" />
        <div className="watermark-processing__doc-line watermark-processing__doc-line--medium" />
      </div>

      {/* Animated scan line */}
      <div className="watermark-processing__scan" aria-hidden="true" />

      {/* Watermark text appearing */}
      <div className="watermark-processing__doc-watermark" aria-hidden="true">
        <span>FILIGRANE</span>
      </div>
    </div>

    {/* Status text */}
    <p className="watermark-processing__label">Traitement en cours…</p>
    <p className="watermark-processing__counter">
      {current} / {total} fichier{total > 1 ? 's' : ''}
    </p>

    {/* Animated dots */}
    <div className="watermark-processing__dots" aria-hidden="true">
      <span /><span /><span />
    </div>
  </div>
);

export default WatermarkProcessing;
